<template>
  <div class="TheBond">

    <slider :items="items" :restart="restartSlider" v-if="items" />

  </div>
</template>

<script>
import Slider from 'components/Slider/Slider'

export default {
  name: 'TheBond',

  components: {
    Slider
  },

  data () {
    return {
      restartSlider: false
    }
  },

  watch: {
    '$route.query.page' () {
      this.$analytics.event(`TheBond/Page${this.$route.query.page}`)
    },

    idleTime () {
      if (this.animals) return
      this.restartSlider = true
    }
  },

  mounted () {
    // Wait a little for the analytics start event to dispatch
    setTimeout(() => {
      this.$analytics.event(`TheBond/Page1`)
    }, 100)
  },

  computed: {
    story () { return this.$store.state.suite.story },
    idleTime () { return this.$store.state.idleTime },

    items () {
      if (!this.story) return

      const items = []

      this.story.forEach(item => {
        const itemObj = {
          image: item.image
        }

        const attrs = ['superTitle', 'title', 'text', 'footerText']

        attrs.forEach(attr => {
          if (!item[attr]) return
          if (itemObj.content === undefined) itemObj.content = {}
          itemObj.content[attr] = item[attr]
        })

        if (itemObj.content !== undefined) {
          itemObj.template = 'text'
        }

        items.push(itemObj)
      })

      return items
    }
  }
}
</script>



// WEBPACK FOOTER //
// TheBond.vue?0e543ca0